import React from 'react';
import { Button } from '@pinwheel/origami';
import { useOpts } from '../context';
import { getWriteJobFromToken } from '../utils';
import eventQueue from '../events/queue';
import { EventAction } from '../types/events';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import { useAppSelector } from '../state';
import { selectMaskedAccounts } from '../state/slices/slice-link-api';
import { selectLinkTokenPayload } from '../state/slices/slice-link-params';
import { checkHackyWorkspace } from '../utils/hacky-workspace-customizations';
export function useShouldShowReopenPinwheelButton() {
    var featureFlags = useOpts().featureFlags;
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var writeJob = getWriteJobFromToken(linkTokenPayload);
    var maskedAccounts = useAppSelector(selectMaskedAccounts);
    if (maskedAccounts.length < 2)
        return false;
    if (!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.multiSwitchButton))
        return false;
    if (!writeJob)
        return false;
    if (checkHackyWorkspace('Citizens', linkTokenPayload.workspaceName)) {
        var channel = (linkTokenPayload.tags || {}).channel;
        if (channel !== 'IPHONE' && channel !== 'ANDROID')
            return false;
    }
    return true;
}
export default function ReopenPinwheelButton() {
    var opts = useOpts();
    var fireProperEventType = opts.fireProperEventType, exit = opts.exit;
    var getLocalizedString = useGetLocalizedString();
    var buttonLabel = getLocalizedString('SET_UP_ANOTHER_ALLOCATION');
    var shouldShow = useShouldShowReopenPinwheelButton();
    if (!shouldShow)
        return null;
    return (React.createElement(Button, { dataTestId: "ReopenPinwheelButton", onClick: function () {
            fireProperEventType(EventAction.EXIT_EXIT, opts);
            eventQueue.emit('another_allocation_expected', {});
            exit();
        }, "aria-label": buttonLabel }, buttonLabel));
}
